<template>
  <span>
    <v-row>
      <v-col cols="12" md="6">
        <ConfirmationColumn :items="leftItems" :submitting="submitting" />
      </v-col>

      <v-col cols="12" md="6"
        ><ConfirmationColumn :items="rightItems" :submitting="submitting"
      /></v-col>

      <v-col cols="12"
        ><ConfirmationColumn :items="items" :submitting="submitting"
      /></v-col>
    </v-row>
  </span>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapMutations } from "vuex";
import ConfirmationColumn from "./ConfirmationColumn.vue";
import moment from "moment";

export default {
  name: "Confirmation",

  props: ["data", "submitting"],

  components: {
    ConfirmationColumn
  },

  mounted() {
    // console.log();
  },

  methods: {
    ...mapMutations("step", ["setStep"]),

    isTable(item) {
      if (_.isArray(item.title)) {
        return true;
      }

      return false;
    }
  },

  computed: {
    items() {
      const { contact_information, sample_details } = this.data;

      return [
        {
          step: 1,
          title: ["Product", "Quantity", "Notes", "Other Samples Notes"],
          lines: sample_details.map(({ sku, quantity, notes, other_sku }) => [
            //(_.isObject(sku))? sku.name : sku,
            sku,
            quantity,
            notes,
            other_sku
          ])
        }
      ];
    },

    leftItems() {
      const { contact_information, shipping_information } = this.data;

      let { requested_arrival_date } = shipping_information;

      if (requested_arrival_date) {
        requested_arrival_date = moment(requested_arrival_date).format(
          "MM/DD/YYYY"
        );
      }

      return [
        {
          step: 0,
          title: "Requestor",
          lines: [contact_information.name, contact_information.email]
        },
        {
          step: 0,
          title: "Company",
          lines: [
            contact_information.company_name,
            contact_information.customer_name
          ]
        },
        {
          step: 2,
          title: "Requested Arrival Date",
          lines: [requested_arrival_date || "N/A"]
        }
      ];
    },

    rightItems() {
      const {
        shipping_information: {
          name,
          company,
          email,
          phone,
          address,
          city,
          state,
          zip,
          country
        }
      } = this.data;

      return [
        {
          step: 2,
          title: "Ship To",
          lines: [
            name,
            company,
            address,
            `${city}, ${state} ${zip}`,
            country,
            "",
            phone,
            email
          ]
        }
      ];
    }
  }
};
</script>

<style scoped>
.confirm-field-title {
  font: normal normal 900 16px/19px Lato;
  letter-spacing: 0px;
  color: #333333;
  text-transform: uppercase;
}
</style>
